export const getTranslations = t => {
  return {
    callSupport: t("Call Support"),
    backToCart: t("Back to Cart"),
    checkout: t("kf.cart.label.checkout"),
    email: t("Email"),
    default: t("Default"),
    password: t("Password"),
    phone: "Phone",
    firstName: "First Name",
    lastName: "Last Name",
    address: "Address",
    aptFloorSuite: "Apt/Floor/Suite",
    city: "City",
    state: "State",
    placeholder: "Please Select",
    zipcode: "Zip Code",
    requiredFields: "Fields marked with * are required.",
    noEmailError: "Please check your email address.",
    validEmail: "Please enter a valid email address.",
    validPassword: "Please enter a valid password.",
    validPhone: "Please enter a valid phone number.",
    validUSPhone:
      "Please enter a valid 10 digit US phone number. Do not include the country code 1.",
    fnameError: "Please provide your first name.",
    lnameError: "Please provide your last name.",
    fnameNumError:
      "Please enter a valid name, numeric are not allowed within name field",
    lnameNumError:
      "Please enter a valid name, numeric are not allowed within name field",
    addressError: "Please provide your street address.",
    cityError: "Please check your city.",
    stateError: "Please check your state.",
    zipcodeError: "Please check your zip code.",
    validZipcode: "Please enter a valid ZIP code.",
    checkoutAsGuest: "Check Out as Guest",
    createAnAccount: "Create an Account",
    welcomeBack: "Welcome back!",
    looksNew: "Looks like you're new!",
    likeToSignin:
      "Looks like we have your email on file, would you like to sign in?",
    likeToSignup:
      "Save your information so you can checkout faster and track orders with ease.",
    youreSignedIn: "You're signed in,",
    save: "Save",
    next: t("kf.checkout.label.next"),
    shippingTo: "Shipping to",
    verifyAddress: "Verify Address",
    originalAddress: "Original Address",
    verifiedAddress: "Verified Address",
    saveAddress: "Save Address",
    verifyAddressDesc:
      "To ensure the delivery accuracy, we recommend using the verified address below.",
    qtyMoreThanStock: (stock, qty) =>
      t("kf.cart.label.qtyMoreThanStock", { qty, stock }),
    chooseAddress: "Please choose what address you would like to use.",
    editAddress: "Edit Address",
    checkoutEditAddress: "Use This Address",
    useOriginal: "Edit My Address",
    cannotVerify: "Sorry, We cannot verify your address.",
    cannotVerifyTitle: "Verified Address",
    contactInfo: "Contact Information",
    shippingAddress: "Shipping Address",
    verified: "Verified",
    unverified: "Unverified",
    signIn: t("kf.checkout.label.signIn"),
    shipping: t("kf.checkout.label.shipping"),
    itemDiscount: t("kf.cart.label.itemdiscount"),
    edit: "Edit",
    successMessage: "Thanks for creating an account",
    zeroAddressUserMessage:
      "Fill in the information below and we'll remember you for a faster checkout next time.",
    selectAddress: "Select a shipping address from your saved address book.",
    addNewAddress: "Add a New Address",
    setAsDefault: "Set as default",
    setDefaultLabel: "Label (ex. Home)",
    setDefaultAddressLabel: "Address Label (Optional)",
    wantToSaveAddress: t("kf.checkout.label.wantToSaveAddress"),
    checkoutFaster: t("kf.checkout.label.checkoutFaster"),
    orderSummary: t("kf.cart.label.orderSummary"),
    subTotal: t("kf.cart.label.subTotal"),
    estimatedShipping: t("kf.cart.label.estimatedShipping"),
    free: t("kf.cart.label.free"),
    editCart: t("kf.cart.label.editCart"),
    freeShipping: t("kf.label.freeShipping"),
    oversizedFragileDelivery: t("kf.checkout.label.oversizedFragileDelivery"),
    shippingInfoAria: t("kf.cart.label.shippingInfoAria"),
    shippingTooltip: t("kf.cart.label.shippingTooltip"),
    totalPromotions: t("kf.cart.label.totalPromotions"),
    removeDiscountErrorMsg: t("kf.cart.label.removeDiscountErrorMsg"),
    removePromoAria: t("kf.cart.label.removePromoAria"),
    estimatedTax: t("kf.cart.label.estimatedTax"),
    taxTooltip: t("kf.cart.label.taxTooltip"),
    total: t("kf.cart.label.total"),
    outOfStockText: t("kf.checkout.label.outOfStockText"),
    estimatedTotal: t("kf.cart.label.estimatedTotal"),
    tax: t("kf.checkout.label.tax"),
    taxInfoAria: t("kf.cart.label.taxInfoAria"),
    profileFailure: t("kf.account.label.profileFailure"),
    reviewTitle: t("kf.checkout.label.reviewTitle"),
    placeOrder: t("kf.checkout.label.placeOrder"),
    termsOfUse: t("kf.checkout.label.termsOfUse"),
    privacyPolicy: t("kf.checkout.label.privacyPolicy"),
    paymentMethod: t("kf.checkout.label.paymentMethod"),
    addPromoCode: t("kf.checkout.label.addPromoCode"),
    selectPayment: t("kf.checkout.label.selectPayment"),
    creditCard: t("kf.checkout.label.creditCard"),
    pciPal: t("kf.checkout.label.pciPal"),
    paypal: t("kf.checkout.label.paypal"),
    qty: t("kf.checkout.label.qty"),
    quantity: t("kf.checkout.label.quantity"),
    unitPrice: t("kf.cart.label.unitPrice"),
    colorFinish: t("kf.cart.label.colorFinish"),
    inStockMsg: t("kf.cart.label.inStockMsg"),
    freightShipping: t("kf.checkout.label.freightShipping"),
    freightLabel: t("kf.orderSUmmary.label.freightLabel"),
    estimatedDelivery: t("kf.checkout.label.estimatedDelivery"),
    businessDays: t("kf.checkout.label.businessDays"),
    comboSkuDelivery: t("kf.checkout.label.comboSkuDelivery"),
    parcelShippingDesc: t("kf.checkout.label.parcelShippingDesc"),
    backOrderMssg: days => t("kf.cart.label.backOrderMssg", { days }),
    inYourCart: count => t("kf.checkout.label.inYourCart", { count }),
    yourCart: count => t("kf.checkout.label.yourCart", { count }),
    loadMore: t("kf.checkout.label.loadMore"),
    loadMoreAria: t("kf.checkout.label.loadMoreAria"),
    parcelShipping: t("kf.checkout.label.parcelShipping"),
    deliveryOptions: t("kf.checkout.label.deliveryOptions"),
    off: t("kf.cart.label.off"),
    review: t("kf.checkout.label.review"),
    agreeMssg: t("kf.checkout.label.agreeMssg"),
    acknowledgeMssg: t("kf.checkout.label.acknowledgeMssg"),
    reviewAddress: t("kf.checkout.label.reviewAddress"),
    taxDownDesc: t("kf.checkout.label.taxDownDesc"),
    continue: t("kf.checkout.label.continue"),
    taxDownTitle: t("kf.checkout.label.taxDownTitle"),
    paymentProcessError: t("kf.checkout.label.paymentProcessError"),
    shippingProcessError: t("kf.checkout.label.shippingProcessError"),
    changePayment: t("kf.checkout.label.changePayment"),
    paymentFailed: t("kf.checkout.label.paymentFailed"),
    productDiscounts: t("kf.cart.label.productDiscounts"),
    paymentDown: t("kf.checkout.label.paymentDown"),
    paymentInfo: t("kf.orderDetails.label.paymentInfo"),
    paymentBilling: t("kf.checkout.label.paymentBilling"),
    endingIn: t("kf.checkout.label.endingIn"),
    billingAddress: t("kf.orderDetails.label.billingAddress"),
    apply: t("kf.promo.button.apply"),
    enterPromo: t("kf.checkout.label.enterPromo"),
    useShippingAsBilling: t("kf.checkout.label.useShippingAsBilling"),
    nameOnCard: t("kf.account.label.nameOnCard"),
    eDelivery: t("kf.checkout.label.eDelivery"),
    eDeliveryNote: t("kf.checkout.label.eDeliveryNote"),
    eDeliveryMssg: t("kf.checkout.label.eDeliveryMssg"),
    eDeliveryTooltip: t("kf.orderDetails.label.eDeliveryTooltip"),
    eDeliveryTextMsg: t("kf.checkout.label.eDeliveryTextMsg"),
    nameValidation: t("kf.checkout.error.invalidCharacters"),
    cityValidation: t("kf.checkout.error.invalidCharacters"),
    editShippingAddress: t("kf.checkout.label.editShippingAddress"),
    addShippingAddress: t("kf.checkout.label.addShippingAddress"),
    editOrUpdateShippingAddress: t(
      "kf.checkout.label.editOrUpdateShippingAddress"
    ),
    addNewShippingAddress: t("kf.checkout.label.addNewShippingAddress"),
    cvvTooltip: t("kf.checkout.label.cvvTooltip"),
    cvv: t("kf.checkout.label.cvv"),
    cardNumber: t("kf.checkout.label.cardNumber"),
    noPromoErr: t("kf.cart.error.noPromoErr"),
    invalidPromoErr: t("kf.cart.error.invalidPromoErr"),
    combinePromoErr: t("kf.cart.error.combinePromoErr"),
    maxAppReachedErr: t("kf.cart.error.maxAppReachedErr"),
    promoNotApplicable: t("kf.cart.error.promoNotApplicable"),
    previousDiscountErr: t("kf.cart.error.previousDiscountErr"),
    alreadyAppliedErr: t("kf.cart.error.alreadyAppliedErr"),
    discountPercentage: t("kf.checkout.label.discountPercentage"),
    itemOf: (index, count) =>
      t("kf.orderDetails.label.itemOf", { index, count }),
    cannotShip: t("kf.checkout.label.cannotShip"),
    bundleRestrictionMessage: t("kf.checkout.label.restrictionMessage"),
    weShipAnywhere: t("kf.checkout.label.weShipAnywhere"),
    updateOrder: t("kf.checkout.label.updateOrder"),
    remove: t("kf.cart.label.remove"),
    outOfStockTitle: t("kf.checkout.label.outOfStockTitle"),
    removeToCheckout: t("kf.checkout.label.removeToCheckout"),
    outOfStock: t("kf.cart.label.outOfStock"),
    addressInstruction: t("kf.checkout.label.addressInstruction"),
    backOrderNote: t("kf.checkout.label.backOrderNote"),
    HaveAccount: t("kf.auth.label.HaveAccount"),
    continueToDelivery: t("kf.cart.label.continueToDelivery"),
    saveAndContinue: t("kf.cart.label.saveAndContinue"),
    continueToBilling: t("kf.cart.label.continueToBilling"),
    shippingInformation: t("kf.checkout.label.shippingInformation"),
    billingInformation: t("kf.checkout.label.billingInformation"),
    delivery: t("kf.checkout.label.delivery"),
    items: t("kf.plp.label.items"),
    item: t("kf.list.table.item"),
    professionalServices: t("kf.checkout.label.professionalServices"),
    allInstructionScheduling: t("kf.checkout.label.allInstructionScheduling"),
    withinBusinessDay: t("kf.checkout.label.withinBusinessDay"),
    continueToPayment: t("kf.cart.label.continueToPayment"),
    instructionSchedulingEmail: t(
      "kf.orderDetails.label.instructionSchedulingEmail"
    ),
    payment: t("kf.cart.label.payment"),
    payWithCreditCard: t("kf.cart.label.payWithCreditCard"),
    affirmPaymentTitle: t("kf.payment.affirm.label"),
    affirmPaymentTitleText: t("kf.payment.affirm.labelText"),
    ReviewYourOrder: t("kf.cart.label.ReviewYourOrder"),
    BillingAddressShipping: t("kf.checkout.label.BillingAddressShipping"),
    PayWithPaypal: t("kf.checkout.label.PayWithPaypal"),
    PaypalRedirectToSignInAccount: t(
      "kf.checkout.label.PaypalRedirectToSignInAccount"
    ),
    usingPaypalBillingAddress: t("kf.checkout.label.usingPaypalBillingAddress"),
    sameAsShippingAddress: t("kf.checkout.label.sameAsShippingAddress"),
    newShippingAddress: t("kf.checkout.label.newShippingAddress"),
    saveAddressMyAccount: t("kf.checkout.label.saveAddressMyAccount"),
    saveChanges: t("kf.checkout.label.saveChanges"),
    saveLabel: t("kf.button.action.save"),
    invalidEmailOrPassword: t("kf.auth.error.invalidEmailOrPassword"),
    needHelpOrder: t("kf.cart.label.needHelpOrder"),
    pleaseSelectOrRemoveFromCart: t(
      "kf.checkout.label.pleaseSelectOrRemoveFromCart"
    ),
    inStock: t("kf.cart.label.inStock"),
    taxCalculatedInNextStep: t("kf.cart.label.taxCalculatedInNextStep"),
    sku: t("kf.cart.label.sku"),
    qtyLabel: t("kf.checkout.label.qtyLabel"),
    saveOnBundle: number => t("kf.pdp.bundles.saveOnBundle", { number }),
    includedItemsQty: number =>
      t("kf.pdp.bundles.includedItemsQty", { number }),
    error: t("kf.payment.aci.error"),
    yourSharedCartID: cartNumber =>
      t("kf.share.label.yourSharedCartID", "Cart ID:", { cartNumber }),
    genericError: t("kf.error.message.genericError"),
    invalidAddress: t("kf.error.message.invalidAddress"),
    promocode: t("kf.cart.label.promocode"),
    saveContinue: t("kf.checkout.label.saveContinue"),
    newsletter: t("kf.checkout.label.newsletter"),
    idealprofessionalsbusinessowners: t(
      "kf.checkout.label.idealprofessionalsbusinessowners"
    ),
    idealhomeownersorpersonaluse: t(
      "kf.checkout.label.idealhomeownersorpersonaluse"
    ),
    enterAddressManually: t("kf.checkout.label.enterAddressManually"),
    addAddressManually: t("kf.checkout.label.addAddressManually"),
    pwdErrorText: t("kf.auth.label.provide.pwdError"),
    businessTypeError: t("kf.auth.error.businessTypeError"),
    subTypeError: t("kf.auth.error.subTypeError"),
    companyNameError: t("kf.auth.label.companyNameError"),
    businessPhoneNumber: t("kf.contactus.label.businessPhone"),
    invalidZipCode: t("kf.checkout.label.invalidZipCode"),
    customerEmailAddress: t("kf.checkout.label.customerEmailAddress"),
    privacyPolicyCheckbox: t("kf.checkout.label.privacyPolicyCheckbox"),
    emailAddress: t("kf.contactus.label.emailAddress"),
    startTypingAddress: t("kf.checkout.label.startTypingAddress"),
    phoneNumber: t("kf.contactus.label.phoneNumber"),
    selectBusinessType: t("kf.contactus.label.businessType"),
    iscContactInfo: t("kf.checkout.label.iscContactInfo"),
    customerShippingAddress: t("kf.checkout.label.customerShippingAddress"),
    checkoutEmailLookupError: t("kf.checkout.label.checkoutEmailLookupError"),
    checkoutDynamicAddressError: t(
      "kf.checkout.label.checkoutDynamicAddressError"
    ),
    checkoutZipcodeApiError: t("kf.checkout.label.checkoutZipcodeApiError"),
    checkoutShippingAddressError: t(
      "kf.checkout.label.checkoutShippingAddressError"
    ),
    checkoutShippingMethodError: t(
      "kf.checkout.label.checkoutShippingMethodError"
    ),
    checkoutCalculateTaxError: t("kf.checkout.label.checkoutCalculateTaxError"),
    checkoutGetProfileError: t("kf.checkout.label.checkoutGetProfileError"),
    checkoutAddAddressError: t("kf.checkout.label.checkoutAddAddressError"),
    locationLabel: t("kf.global.label.location"),
    inPersonLabel: t("kf.cart.label.inperson"),
    poBoxAddressError: t("kf.checkout.label.checkoutPOBoxAddressError"),
    iscEmail: t("kf.checkout.label.iscEmail"),
    iscCustomerName: t("kf.checkout.label.iscCustomerName"),
    iscCustomerAddress: t("kf.checkout.label.iscCustomerAddress"),
    iscPhoneNo: t("kf.checkout.label.iscPhoneNo"),
    iscManualCustAddress: t("kf.checkout.label.iscManualCustomerAddress"),
    emptyZipcodeError: t("kf.checkout.label.emptyZipcodeError"),
    invalidZipcodeError: t("kf.checkout.label.invalidZipcodeError"),
    emptyPhoneError: t("kf.checkout.label.emptyPhoneError"),
    country: t("kf.checkout.label.country"),
    addressLabelText: t("kf.checkout.label.addressLabelText"),
    addressLabelMobileText: t("kf.checkout.label.addressLabelMobileText"),
    nonDeliverableAddress: t("kf.checkout.label.nonDeliverableAddress"),
    completeDelivery: t("kf.checkout.label.completeDelivery"),
    paymentRefreshBtnText: t("kf.checkout.label.paymentRefreshBtnText"),
  }
}
